"use strict";
/**
 * @copyright   2016-2019, Miles Johnson
 * @license     https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Filter = /** @class */ (function () {
    function Filter() {
    }
    /**
     * Filter and clean an HTML attribute value.
     */
    Filter.prototype.attribute = function (name, value) {
        return value;
    };
    /**
     * Filter and clean an HTML node.
     */
    Filter.prototype.node = function (name, node) {
        return node;
    };
    return Filter;
}());
exports.default = Filter;
